<template>
  <v-container fluid class="pa-0">
    <breadcrumbs-banner
      :bannerTitle="$t('header.incoceglaFoundation')"
    ></breadcrumbs-banner>
    <v-container class="py-lg-16 pa-10 pa-sm-14 px-lg-3" v-if="foundations">
      <v-row>
        <v-col cols="12" lg="6">
          <h3
            class="text-lg-h3 text-h5 text-navy font-weight-bold"
            v-html="foundations[0].name"
          ></h3>
          <p
            class="text-navy font-weight-light text-justify mt-lg-5 mr-lg-10"
            v-html="foundations[0].description"
          ></p>
        </v-col>
        <v-col cols="12" lg="6">
          <v-img
            :src="foundations[0].upload.path"
            class="mx-auto rounded-lg"
          ></v-img>
        </v-col>
      </v-row>
     
      <v-row class="my-lg-16 my-10">
        <v-col cols="12">
          <h3
            class="text-lg-h3 text-h5 text-navy font-weight-bold"
            v-html="$t('aboutUs.projects')"
          ></h3>
        </v-col>
        <v-col cols="12"> </v-col>
        <carousel-3d
          :controls-visible="true"
          :clickable="false"
          :display="3"
          :perspective="10"
          :inverse-scaling="30"
          :space="70"
          :width="700"
          :height="450"
          v-if="projects"
        >
          <slide
            v-for="(project, i) in projects"
            :key="i"
            :index="i"
            class="rounded-lg border-0"
          >
            <v-img :src="project.upload.path" width="100%" height="100%" />
          </slide>
        </carousel-3d>
      </v-row>
    </v-container>
    <advertising-banner
      v-if="foundations"
      :title="foundations[1].name"
      :message="foundations[1].description"
    ></advertising-banner>
  </v-container>
</template>
<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
import advertisingBanner from "../../components/advertisingBanner.vue";
import AboutUsService from "@/services/aboutUs";

export default {
  name: "IncoceglaFoundation",
  components: {
    Carousel3d,
    Slide,
    advertisingBanner,
  },
  data() {
    return {
      projects: "",
      foundations: ""
    };
  },

  async created(){
    this.foundations = await AboutUsService.getFoundation();
    this.projects = await AboutUsService.getFoundationProjects();
  }
};
</script>